export enum InstitutionIntegrationType {
  canvas = 'canvas',
  // The LMS is branded "D2L" in the product. The stored value stays
  // 'brightspace' for backward compatibility with existing Firestore
  // integration documents (no data migration).
  d2l = 'brightspace',
}
